<template>
  <section
    :id="team_slug"
    class="main-section main-section--white foldaz-section"
  >
    <div class="container">
      <div class="text-center add-margin-bottom-full">
        <h2 class="h1 add-margin-bottom">
          {{ team_name }}
        </h2>
        <div class="text-medium text-disabled">
          <div v-if="isLoading">Loading ...</div>
          <div v-else>
            <span class="fa fa-folder" />
            {{ $tc('c.teamWithFolders.label.folders', team.foldersCount, {count: team.foldersCount}) }}
            &nbsp;
            &nbsp;
            <span class="fa fa-user" /> {{ team.membershipsCount | pluralize('Mitglied', 'Mitglieder') }}
          </div>
        </div>
      </div>

      <div class="row">
        <div
          v-for="folder in folders"
          :key="folder.id"
          class="col-md-6 col-lg-4 folda-row"
        >
          <folder :folder="folder" />
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import pluralize from '@/filters/pluralize'
import Folder from '@/components/folders/Folder'

export default {
  name: 'Team',
  filters: {
    pluralize
  },
  components: {
    Folder
  },
  props: {
    team: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: true,
      folders: []
    }
  },
  computed: {
    ...mapGetters([
      'teamFolders'
    ]),
    team_name () {
      return this.team.visibility === 'is_personal' ? `${this.team.name} (persönlich)` : this.team.name
    },
    team_slug () {
      return 'team-' + this.team.slug
    }
  },
  methods: {
    ...mapActions([
      'fetchTeamFolders'
    ])
  },
  created () {
    this.fetchTeamFolders(this.team.id).then(({ folders }) => {
      this.folders = folders
      this.isLoading = false
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/teams/TeamWithFolders.vue